export default __webpack_public_path__ + "static/media/commission.bccacbda.svg";